import { FC } from 'react'

import { FilterChip } from 'components/atoms/FilterChip'
import { capitalizeFirstLetter } from 'utils/capitalizeFirstLetter'
import { formatPartnerOrderDateBound } from 'utils/partnerOrderDateBound'

export interface FilterChipSectionProps {
  [x: string]: any
}

/** This is FilterChipSection */

export const FilterChipSection: FC<FilterChipSectionProps> = ({
  filterSectionKey,
  partnerOrderVariables,
  startDateValue,
  endDateValue,
  setPartnerOrderVariables,
  setPageNumber,
  partnerList,
  orderTypeList,
}: FilterChipSectionProps) => {
  const resetStatusFilter = (element: string) => {
    setPageNumber(1)
    partnerOrderVariables.status?.length === 1
      ? setPartnerOrderVariables({
          ...partnerOrderVariables,
          status: ['ALL'],
        })
      : setPartnerOrderVariables({
          ...partnerOrderVariables,
          status: partnerOrderVariables?.status?.filter(
            (status: string) => status !== element,
          ),
        })
  }

  const resetInternationalFilter = () => {
    setPageNumber(1)
    setPartnerOrderVariables({
      ...partnerOrderVariables,
      isInternational: false,
    })
  }

  const resetPartnerFilter = (element: string) => {
    setPageNumber(1)
    setPartnerOrderVariables({
      ...partnerOrderVariables,
      partner: '',
      partnerCodes: partnerOrderVariables?.partnerCodes?.filter(
        (code: string) => code !== element,
      ),
    })
  }

  const resetOrderTypeFilter = () => {
    setPageNumber(1)
    setPartnerOrderVariables({
      ...partnerOrderVariables,
      orderType: null,
      partnerOrderTypes: [],
    })
  }

  const resetDateFilter = () => {
    setPageNumber(1)
    setPartnerOrderVariables({
      ...partnerOrderVariables,
      /** Shared formatter — keeps the reset bounds identical to the seeds in Orders.tsx (BDL20-3126). */
      from: formatPartnerOrderDateBound(startDateValue, false),
      to: formatPartnerOrderDateBound(endDateValue, true),
    })
  }

  return (
    <div
      className='flex w-full items-center justify-start'
      key={filterSectionKey}>
      {partnerOrderVariables.status[0] !== 'ALL' &&
        partnerOrderVariables.status !== '' &&
        partnerOrderVariables.status?.map((element: any) => (
          <FilterChip
            labelValue='Status'
            filterValue={capitalizeFirstLetter(
              element === 'TOBECONSIGNED'
                ? 'To be consigned'
                : element === 'BACKORDER'
                ? 'Back Order'
                : element,
            )}
            onClick={() => {
              resetStatusFilter(element)
            }}
          />
        ))}
      {partnerOrderVariables?.partnerCodes?.length > 0 &&
        !partnerOrderVariables?.partnerCodes?.includes('') &&
        partnerOrderVariables.partnerCodes.map((code: string) => {
          const partnerLabel =
            partnerList.find((p: any) => p.label.startsWith(code + ' -'))
              ?.label ?? code

          return (
            <FilterChip
              key={code}
              labelValue='Partner'
              filterValue={partnerLabel}
              onClick={() => resetPartnerFilter(code)}
            />
          )
        })}

      {(partnerOrderVariables?.orderType?.value !== undefined ||
        partnerOrderVariables?.partnerOrderTypes?.length > 0) && (
        <FilterChip
          labelValue='Order Type'
          filterValue={partnerOrderVariables?.partnerOrderTypes.join(', ')}
          onClick={() => {
            resetOrderTypeFilter()
          }}
        />
      )}
      {!(
        partnerOrderVariables.from.toString() ===
          formatPartnerOrderDateBound(startDateValue, false) &&
        partnerOrderVariables.to.toString() ===
          formatPartnerOrderDateBound(endDateValue, true)
      ) && (
        <FilterChip
          labelValue='Date'
          filterValue={`${partnerOrderVariables.from} to ${partnerOrderVariables.to}`}
          onClick={() => {
            resetDateFilter()
          }}
        />
      )}
      {partnerOrderVariables.isInternational && (
        <FilterChip
          labelValue='International Orders'
          filterValue={partnerOrderVariables.isInternational && 'True'}
          onClick={() => {
            resetInternationalFilter()
          }}
        />
      )}
    </div>
  )
}

FilterChipSection.defaultProps = {}

export default FilterChipSection
